import BaseEntityService from 'vue-core/services/BaseEntityService';
import env from 'environment';

class WorkgroupService
    extends BaseEntityService {
  constructor() {
    super({
      baseUrl: env.baseUrl + '/workgroups'
    });
  }
}

const service = new WorkgroupService();

export default service;
